module.exports = __webpack_public_path__ + "static/img/louvre.0634f32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/louvre.jpg
// module id = h96m
// module chunks = 1